module.exports = __webpack_public_path__ + "static/media/mehdi.7442f6a0.png";